import { render, staticRenderFns } from "./ReplacementsMercEditor.vue?vue&type=template&id=912c2b46&scoped=true&"
import script from "./ReplacementsMercEditor.vue?vue&type=script&lang=js&"
export * from "./ReplacementsMercEditor.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementsMercEditor.vue?vue&type=style&index=0&id=912c2b46&scoped=true&lang=css&"
import style1 from "./ReplacementsMercEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912c2b46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VSelect,VTextField})
